import axios from "axios";
import LanguageService from "@/services/LanguageService";
import Constants from "@/services/Constants";

export default {
	async getInfoBlocks() {
		let res = await axios.get(`${Constants.backend}/infoblocks/${LanguageService.langId}/`);
		return res.data;
	},
}